import { createModel, RematchDispatch } from '@rematch/core';
import { message } from 'antd';
import produce from 'immer';
import { DEFAULT_PAGINATION } from '../../../commons/constants/constants';
import { PageRequest, PaginationType } from '../../../types/CommonTypes';
import { storeName as entityStore } from '../../entities/admin/tourAdmin.entity';
import { RootModel } from '../../models';

export const storeName = 'tourAdmin';

export interface initialValuesType {
  ids: (number | string)[];
  pagination: PaginationType | null;
  criteria: { [key: string]: any };
  loading: boolean;
}

const initialState: initialValuesType = {
  ids: [],
  pagination: DEFAULT_PAGINATION,
  criteria: {},
  loading: false,
};

export const tourAdmin: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setIds: produce((state, payload) => {
      state.ids = payload;
    }),
    setPagination: produce((state, payload) => {
      state.pagination = payload;
    }),
    setCriteria: produce((state, payload) => {
      state.criteria = payload;
    }),
    setLoading: produce((state, payload) => {
      state.loading = payload;
    }),
  },
  effects: (dispatch: RematchDispatch<typeof tourAdmin>) => ({
    async reloadList(payload, state) {
      const { criteria, pagination } = state[storeName];
      await this.filterAsync({ ...pagination, ...criteria });
    },
    async resetFilter(payload, state) {
      const { pagination } = state[storeName];
      await this.filterAsync({ ...pagination, page: 0 });
    },
    async pagingAsync(payload: PageRequest, state) {
      const { criteria = {}, pagination = {} } = state[storeName];
      await this.filterAsync({ ...pagination, ...criteria, ...payload });
    },
    async filterAsync(params = {}, state) {
      this.setLoading(true);
      try {
        const data = await dispatch[entityStore].load(params);
        if (data && data.content) {
          this.setIds(data.content.map((tour) => tour.id));
          this.setPagination((({ content, ...otherProps }) => otherProps)(data));
          this.setCriteria(params);
        }
      } catch (e) {
        console.error(e);
        message.error('Failed to filter tours');
      } finally {
        this.setLoading(false);
      }
    },
  }),
});

export default tourAdmin;
